import type { FormConfig } from '@tencent/wb-ext-form';
import { FormItemLabelName, FormItemType } from '@framework/workbench/drawer/constants';
import { ChartFormItemKey } from '@tencent/chart-drawer-components/lib/schema';
import i18n from '@i18next/i18n';
import { COLOR_STYLE } from '@src/framework/workbench/drawer/common/config';
import { OpacityOptions, AngleOptions } from '@framework/workbench/drawer/common/config';

export const SIZE_MAX = 200;
export const DIST_MAX = 200;

export const FORM_CONFIGS: FormConfig[] = [
    {
        type: FormItemType.CUSTOM,
        name: ChartFormItemKey.CHART_GLOBAL_SHADOW,
        content: '',
    },
    {
        type: FormItemType.SLIDER,
        name: ChartFormItemKey.CHART_GLOBAL_SHADOW_SIZE,
        label: FormItemLabelName.SIZE,
        options: {
            suffix: '%',
            max: SIZE_MAX,
            step: 1,
        },
        defaultValue: 0,
    },
    {
        type: FormItemType.SLIDER,
        name: ChartFormItemKey.CHART_GLOBAL_SHADOW_BLUR,
        label: FormItemLabelName.BLUR,
        options: {
            suffix: i18n.t('磅'),
            allowDecimal: true,
            toFixed: 2,
            maxLength: 6,
        },
        defaultValue: 0,
    },
    {
        type: FormItemType.SLIDER,
        name: ChartFormItemKey.CHART_GLOBAL_SHADOW_DISTANCE,
        label: FormItemLabelName.DIST,
        options: {
            suffix: i18n.t('磅'),
            max: DIST_MAX,
            allowDecimal: true,
            toFixed: 1,
            maxLength: 6,
        },
        defaultValue: 0,
    },
    {
        type: FormItemType.SLIDER,
        name: ChartFormItemKey.CHART_GLOBAL_SHADOW_OPICITY,
        label: FormItemLabelName.OPACITY,
        options: {
            ...OpacityOptions,
        },
        defaultValue: 0,
    },
    {
        type: FormItemType.ANGLE,
        name: ChartFormItemKey.CHART_GLOBAL_SHADOW_ANGLE,
        label: FormItemLabelName.ANGLE,
        options: {
            ...AngleOptions,
        },
        style: {
            minWidth: 160,
        },
        defaultValue: 0,
    },
    {
        type: FormItemType.CUSTOM,
        name: ChartFormItemKey.CHART_GLOBAL_SHADOW_COLOR,
        options: {
        },
        style: COLOR_STYLE,
    },
];
